<template>
	<common-welcomebox
		card-type="dismiss"
		title="Three Easy Steps to Get Started Using OptinMonster"
		:hide-button="true"
		@dismiss="dismiss({ key: 'WelcomeBack' })"
	>
		<p>We're so excited for you to begin publishing your OptinMonster campaigns!</p>
		<p>
			Learn how by watching the video to the right or click the button below to read our simple Guide to Getting
			Started with OptinMonster and WordPress.
		</p>
		<core-button
			:arrow="true"
			size="monster"
			color="green"
			:href="$urls.docs('getting-started-optinmonster-wordpress-checklist', 'WelcomeBackPlugin')"
			target="_blank"
			rel="noopener"
		>
			<span style="white-space: nowrap">Get Started Now</span>
		</core-button>
	</common-welcomebox>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
	methods: {
		...mapMutations('dashboard', ['dismiss']),
	},
};
</script>
